"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const svgs_1 = __importDefault(require("./svgs"));
exports.default = {
    icon: props => ({
        width: Number(props.size) || 'inherit',
        height: Number(props.size) || 'inherit',
        backgroundColor: props.color || 'currentColor',
        mask: `url(${svgs_1.default[props.name]}) no-repeat center`,
        '-webkit-mask': `url(${svgs_1.default[props.name]}) no-repeat center`
    })
};
//# sourceMappingURL=icons.style.js.map